import axios from "axios";

const apiOptimization = axios.create({
  baseURL: process.env.REACT_APP_BOVEXO_OPTIMIZATION_URL,
  validateStatus: (status) => status >= 200 && status < 300,
  // baseURL: "http://localhost:8088",
});

export default apiOptimization;
